<script>
import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import validateZhTw from 'vee-validate/dist/locale/zh_TW'
import { 
  merchantComputed,
  setComputed,
  authMethods,
} from '@state/helpers'

import { mask } from 'vue-the-mask'

import CountryCallingCodePicker from '@components/CountryCallingCodePicker'
import ModalTerms from '@components/modal/ModalTerms'

import hotkeys from 'hotkeys-js'

Vue.use(VeeValidate, { events: 'input|blur' });
Validator.localize('zh_TW', validateZhTw);

export default {
  components: {
    CountryCallingCodePicker,
    ModalTerms
  },
  directives: { mask },
  data() {
    return {
      isCodePickerActive: false,
      loginProcessing: false,
      isResendProcessing: false,
      isTermsModalActive: false,
      resendProcessing: 0,
      step: 1,
      loginData: {
        phoneCode: '+886',
        phoneNumber: '',
        verificationCode: '',
        lineLinkToken: this.$route.params.lineLinkToken,
        merchantAlias: this.$route.params.merchantAlias
      },
      /* loginData: {
        phoneCode: '+886',
        phoneNumber: '0912345678',
        verificationCode: '0000',
        lineLinkToken: this.$route.params.lineLinkToken,
        merchantAlias: this.$route.params.merchantAlias
      }, */
    }
  },
  computed: {
    ...merchantComputed,
    ...setComputed,
    isFormValid() {
      return Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    isOfficial() {
      return location.host === 'ibobee.tw'
    },
    merchantAlias() {
      return this.$route.params.merchantAlias || this.currentMerchant.alias;
    }
  },
  mounted() {
    this.loginData.merchantAlias = this.merchantAlias;

    document.addEventListener('keydown', this.testKeydown);

    // this.autoCom;
    /* hotkeys('shift+z', (event, handler) => {

    }); */
  },
  destroyed() {
    document.removeEventListener('keydown', this.testKeydown);
  },
  methods: {
    ...authMethods,
    testKeydown(event) {
      if(window.globalData.APP_ENV === 'local' || window.globalData.APP_ENV === `{{config('app.env')}}`) {
        const e = event || window.event;
        if(e.keyCode === 65) console.log('a')
        if(e.keyCode === 90) console.log('z')
        if(e.shiftKey) console.log('shift')
        if (e.keyCode === 90 && e.keyCode === 65) console.log('asdasdasdasd')
        if (e.keyCode === 90 && e.shiftKey) {
          this.testAutoComplate()
        }
      }
    },
    testAutoComplate() {
      console.log('自動完成');
      this.loginData.phoneCode = '+886';
      this.loginData.phoneNumber = '0912345678';
      this.loginData.verificationCode = '0000';
    },
    onClose() {
      this.$emit('close')
    },
    handleGetCode() {
      this.loginProcessing = true;

      this.getCode(this.loginData)
        .then((response) => {
          if(response.code === 200) {
            this.step = 2;
            this.resendProcessing = 60;
            this.handleResend();
          }else if(response.status === 'MERCHANT_MEMBER_FRONT_SEND_VERIFICATION_CODE_IN_COOL_DOWN') {
            this.step = 2;
          }else {
            this.$toast.open({
              type: 'is-danger',
              message: this.$t(`error.${response.status}`),
            });
          }
        })
        .finally(() => (this.loginProcessing = false));
    },
    handleLogIn() {
      this.loginProcessing = true;

      this.logIn(this.loginData)
        .then((response) => {
          if(response.token) {
            this.$toast.open(this.$t('global.LOGIN_SUCCESS'/* 驗證成功 */));
            this.$emit('login');
            this.onClose();
          }else {
            this.$toast.open({
              type: 'is-danger',
              message: this.$t(`error.${response.status}`),
            });
          }
        })
        .finally(() => (this.loginProcessing = false));
    },
    handleResend() {
      if(!this.isResendProcessing) {
        this.resendProcessing = 60;
        this.isResendProcessing = true
      }else {
        this.resendProcessing -= 1;
      }

      if(this.resendProcessing <= 0) {
        this.isResendProcessing = false
      }else {
        setTimeout(()=> {
          this.handleResend();
        }, 1000)
      }
    },
    handleSubmitForm() {
      this.loginProcessing = true;

      if(this.step === 1) {
        this.handleGetCode()
      }
      if(this.step === 2) {
        this.handleLogIn()
      }
    },
  },

}
</script>
<template>
  <div :class="$style['modalWrapper']" style="width: auto">
    <header class="modal-card-head is-style-no-border">
      <p class="modal-card-title"></p>
      <div :class="$style['modalClose']" class="delete" @click="onClose"></div>
    </header>
    <transition-group name="fade-left" mode="out-in">
      <div v-if="step === 1" key="login">
        <section class="modal-card-body">
          <div :class="$style.titleBox">
            <div :class="$style.title">
              <span v-if="$route.name === 'line login'">{{ $t('global.LIGHT_BOX_LINE_LOGIN_TITLE'/*連結您的Line帳號*/) }}</span>
              <span v-else>{{ $t('global.LIGHT_BOX_LOGIN_TITLE'/*驗證*/) }}</span>
            </div>
            <div class="has-text-grey-light">{{ $t('global.LIGHT_BOX_LOGIN_CONTENT'/*為確保資訊安全，請先完成手機號碼驗證*/) }}</div>
          </div>
          <form
            ref="form"
            @submit.prevent="handleGetCode"
          >
            <b-field
              :class="$style['isRequired']"
              expanded
            >
              <b-field
                :class="$style['fieldNested']"
                :type="{ 'is-danger': errors.has('phoneNumber') }"
                :message="errors.first('phoneNumber') ? $t('global.VERIFICATION_PHONE'/* 請輸入正確的手機號碼格式, 09XXXXXXXX */) : ''"
              >
                <div class="control">
                  <b-button
                    outlined
                    rounded
                    class="is-select-style"
                    @click="isCodePickerActive = true"
                  >{{ loginData.phoneCode }}</b-button>
                  <b-modal
                    :active.sync="isCodePickerActive"
                    :width="400"
                    :can-cancel="['escape','outside']"
                  >
                    <CountryCallingCodePicker :value.sync="loginData.phoneCode" />
                  </b-modal>
                </div>
                <b-input
                  v-model="loginData.phoneNumber"
                  v-validate="loginData.phoneCode === '+886' ? 'required|digits:10|regex:^09' : ''"
                  :data-vv-as="$t(`global.PHONE`/* 手機號碼 */)"
                  name="phoneNumber"
                  placeholder="ex: 0912345678"
                  type="tel"
                  rounded
                  expanded
                  @keyup.native.enter="handleGetCode"
                ></b-input>
              </b-field>
            </b-field>
            <b-field>
              <b-button
                type="is-primary"
                class="is-fullwidth"
                :loading="loginProcessing"
                :disabled="loginProcessing || isFormValid"
                rounded
                @click="handleGetCode"
              >{{ $t('global.SEND_CODE'/*發送驗證碼*/) }}</b-button>
            </b-field>
            <b-field>
              <div>{{ $t('global.LIGHT_BOX_LOGIN_TIP'/*驗證後即代表*/) }}<a @click="isTermsModalActive = true">{{
                $t('global.AGREE'/*同意*/) }} {{ $t('global.TERMS_OF_SERVICE'/*i保庇 服務條款*/) }}</a></div>
            </b-field>
          </form>
          <b-modal

            :active.sync="isTermsModalActive"
            :width="650"
            :can-cancel="['escape','outside']"
          >
            <ModalTerms @close="isTermsModalActive = false"/>
          </b-modal>
        </section>
      </div>
      <div v-if="step === 2" key="verification">
        <section class="modal-card-body">
          <div :class="$style.titleBox">
            <div :class="$style.title">{{ $t('global.LIGHT_BOX_LOGIN_CODE_TITLE'/*驗證*/) }}</div>
            <div class="has-text-grey-light">{{ $t('global.LIGHT_BOX_LOGIN_CODE_CONTENT',
              { num: isOfficial ? 6 : 4 }/*請輸入簡訊傳送的{num}位數驗證碼*/) }}
            </div>
          </div>
          <form @submit.prevent="handleLogIn">
            <b-field
              :class="[$style['isRequired'], $style['fieldNested']]"
              expanded
            >
              <b-field
                :type="{ 'is-danger': errors.has('phoneNumber') }"
                :message="errors.first('phoneNumber') ? $t('global.VERIFICATION_PHONE'/* 請輸入正確的手機號碼格式, 09XXXXXXXX */) : ''"
              >
                <b-input
                  v-model="loginData.verificationCode"
                  v-validate="isOfficial ? 'required|min:6' : 'required|min:4'"
                  v-mask="isOfficial ? '######' : '####'"
                  :data-vv-as="$t('global.PHONE_CODE'/* 手機驗證碼 */)"
                  name="verification"
                  :placeholder="isOfficial ? '・・・・・・' : '・・・・'"
                  type="tel"
                  rounded
                  expanded
                ></b-input>
                <div class="control">
                  <b-button
                    :disabled="isResendProcessing"
                    outlined
                    rounded
                    @click="handleResend"
                  >
                    {{ $t('global.RESEND'/*重新傳送*/) }} <span v-if="resendProcessing > 0">({{resendProcessing}}s)</span>
                  </b-button>
                </div>
              </b-field>
            </b-field>
            <b-field>
              <b-button
                type="is-primary"
                class="is-fullwidth"
                :loading="loginProcessing"
                :disabled="isFormValid"
                rounded
                @click="handleLogIn"
              >{{ $t('global.CONFIRM'/* 確認 */) }}</b-button>
            </b-field>
            <b-field>
              <div>{{ $t('global.LIGHT_BOX_LOGIN_TIP'/*驗證後即代表*/) }}<a @click="isTermsModalActive = true">{{
                $t('global.AGREE'/*同意*/) }} {{ $t('global.TERMS_OF_SERVICE'/*i保庇 服務條款*/) }}</a></div>
            </b-field>
          </form>
          <b-modal
            :active.sync="isTermsModalActive"
            :width="650"
            :can-cancel="['escape','outside']"
          >
            <ModalTerms @close="isTermsModalActive = false"/>
          </b-modal>
        </section>
      </div>
    </transition-group>

  </div>
</template>
<style lang="scss" module>
  .title {
    @extend %typography-medium;

    margin-bottom: 1rem;
    font-weight: 500;
    color: $color-primary;
    text-transform: capitalize;
  }

  .titleBox {
    margin-bottom: 5rem;
  }

  .fieldNested {
    flex-wrap: wrap;
    :global(.help) {
      width: 100%;
    }
    :global(.is-expanded) {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
  }

  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }

  .modalWrapper {
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    text-align: center;
    background: white;
    border-radius: $size-section-border-radius;
  }

  .modalClose {
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }

    &::before,
    &::after {
      background-color: $grey;
    }

    &::after {
      height: 100%;
    }

    &::before {
      width: 100%;
    }
  }
</style>
